// console.log('custome js worjing');

$(function(){
    // $('#SenderInfo').on('click', function (){
    //     if($("#SenderInfo").prop('checked') == true){
          
    //        $('#showSenderInfo').slideToggle();
    //     }
    //     else
    //     {
    
    //       $('#showSenderInfo').slideToggle();
    //     }
    //   })
    
    //   $('#numberOfDownload').on('click', function (){
    //     if($("#numberOfDownload").prop('checked') == true){
          
    //        $('#downloadCountShow').slideToggle();
    //     }
    //     else
    //     {
    
    //       $('#downloadCountShow').slideToggle();
    //     }
    //   })
    
    
    //   $('#fileAvailable').on('click', function (){
    //     if($("#fileAvailable").prop('checked') == true){
          
    //        $('#fileAvailableShow').slideToggle();
    //     }
    //     else
    //     {
    
    //       $('#fileAvailableShow').slideToggle();
    //     }
    //   })



      
  
})
